import { render, staticRenderFns } from "./OptionWidget.vue?vue&type=template&id=08ded614&scoped=true&"
import script from "./OptionWidget.vue?vue&type=script&lang=ts&"
export * from "./OptionWidget.vue?vue&type=script&lang=ts&"
import style0 from "./OptionWidget.vue?vue&type=style&index=0&id=08ded614&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ded614",
  null
  
)

export default component.exports